export default __webpack_public_path__ + "static/media/MAGAM_PAVAN_ADITHYA.d0c1cbea.jpg";